import { render, staticRenderFns } from "./TableZone.vue?vue&type=template&id=58c834c0&scoped=true&"
import script from "./TableZone.vue?vue&type=script&lang=js&"
export * from "./TableZone.vue?vue&type=script&lang=js&"
import style0 from "./TableZone.vue?vue&type=style&index=0&id=58c834c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c834c0",
  null
  
)

export default component.exports